import { useContext } from 'react';
import PortfolioItemContext from '../../../../PortfolioItemContext';
import FieldContext from '../../FieldContext';
import { type UploadedImage } from '@/lib/types';

const useFieldImages = (): UploadedImage[] => {
  const { portfolioItem } = useContext(PortfolioItemContext);
  const field = useContext(FieldContext);

  const fieldValue = portfolioItem.fieldValues[field.id];

  if (typeof fieldValue === 'undefined') {
    return [];
  }

  return Object.values(fieldValue.images);
};

export default useFieldImages;
